import type { ComponentPropsWithoutRef } from 'react';
import { cx } from '../../utils/cx';
import s from './Heading.module.css';

export type HeadingLevel = 1 | 2 | 3;
export type HeadingSize = 'display' | 'h1' | 'h2' | 'h3';

export type HeadingProps = ComponentPropsWithoutRef<'h1'> & {
  /** Semantic level (h1–h3). */
  level: HeadingLevel;
  /** Visual size, if it should differ from the level. */
  size?: HeadingSize;
};

export function Heading({ level, size, className, ...rest }: HeadingProps) {
  const Tag = `h${level}` as const;
  return <Tag className={cx(s.heading, className)} data-size={size ?? `h${level}`} {...rest} />;
}
